export const PencilIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g>
        <path d="M14.7842 4.803L19.1971 9.21592M1.5 22.5L5.78491 21.6843C6.69344 21.5114 7.52897 21.0692 8.18294 20.4152L21.5477 7.05046C22.8174 5.78072 22.8174 3.72205 21.5477 2.45231C20.2779 1.18256 18.2193 1.18257 16.9495 2.45231L3.58479 15.8171C2.93082 16.471 2.48864 17.3066 2.31568 18.2151L1.5 22.5Z" />
      </g>
    </svg>
  );
};
